export default __webpack_public_path__ + "static/gaming_journey_1-898d6efb7b6922ad0f2225737ab36109.jpg";